import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class PermissoesService {
  constructor(private http: HttpClient, private oauthService: OAuthService) {}

  getPermissoes(): Observable<Array<string>> {
    let headers = this.getHttpHeaders();

    return this.http.get<Array<string>>(environment.avmBaseUrl + '/cadastro-servicos/admin/permissoes', { headers });
  }

  private getHttpHeaders(): HttpHeaders {
    return new HttpHeaders({
      Authorization: 'Bearer ' + this.oauthService.getAccessToken(),
      'Access-Control-Allow-Origin': '*',
    });
  }
}
